import { CSSProperties } from 'react';

// Shared visual tokens so all sections look consistent with the design.

// Light-blue rounded pill used in section headers (e.g. "5,431 alumni").
export const badgePill: CSSProperties = {
    background: '#e9f1fb',
    color: '#2f6fdb',
    borderRadius: 999,
    padding: '5px 14px',
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: 'nowrap',
};

// Small blue pill for percentage values in the breakup lists.
export const pctPill: CSSProperties = {
    background: '#e9f1fb',
    color: '#2f6fdb',
    borderRadius: 999,
    padding: '3px 10px',
    fontSize: 12,
    fontWeight: 600,
};

// Company tag chip under each breakup row.
export const companyChip: CSSProperties = {
    display: 'inline-block',
    background: '#eef3f9',
    color: '#3a4a5c',
    borderRadius: 6,
    padding: '2px 8px',
    fontSize: 11,
    fontWeight: 500,
};

export const companyChipLink: CSSProperties = {
    ...companyChip,
    color: '#2f6fdb',
    cursor: 'pointer',
    textDecoration: 'none',
};

export const breakupNameLink: CSSProperties = {
    color: '#2f6fdb',
    textDecoration: 'none',
    cursor: 'pointer',
};

// Dark tooltip captioning the company chips ("Top companies for this …"),
// shown while the chip row is hovered.
export const companiesTooltip: CSSProperties = {
    position: 'absolute',
    bottom: '100%',
    left: 0,
    marginBottom: 6,
    background: '#1f2733',
    color: '#ffffff',
    borderRadius: 8,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    zIndex: 20,
    boxShadow: '0 6px 18px rgba(0,0,0,.22)',
};

// Neutral count pill (revenue table).
export const neutralPill: CSSProperties = {
    background: '#eef1f4',
    color: '#33475b',
    borderRadius: 999,
    padding: '3px 12px',
    fontSize: 12,
    fontWeight: 600,
};

export const countLink: CSSProperties = {
    ...neutralPill,
    color: '#2f6fdb',
    cursor: 'pointer',
    textDecoration: 'none',
};

export const mutedLabel: CSSProperties = {
    color: '#8a97a5',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
};
